import React from "react";
import "./Testimonials.css";
import { Data } from "./Data";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

export default function TestiMonials() {
  return (
    <section className="testmonial container section" id="Testimonial">
      <h2 className="section__title">Team Testimonials</h2>
      <span className="section__subtitle">What My Colleagues Say</span>
      <Swiper
        loop={true}
        className="testimonial__container"
        spaceBetween={24}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 48,
          },
        }}
        modules={[Pagination]}
      >
        {Data.map((tm) => (
          <SwiperSlide className="testimonial__card" key={tm.id}>
            <img src={tm.image} alt="" className="testimonial__img" />
            <h3 className="testimonial__name">{tm.title}</h3>
            <p className="testimonial__des">{tm.description}</p>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
